import { render, staticRenderFns } from "./BlockPage.vue?vue&type=template&id=1d230609&scoped=true"
import script from "./BlockPage.vue?vue&type=script&lang=js"
export * from "./BlockPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d230609",
  null
  
)

export default component.exports